import Enum from 'es6-enum';

export const AUTH_STATES = {
  SIGNED_OUT: 'SIGNED_OUT',
  SIGNED_IN: 'SIGNED_IN',
  SIGNING_IN: 'SIGNING_IN',
  SIGNING_OUT: 'SIGNING_OUT',
  SIGNIN_FAILED: 'SIGNIN_FAILED',
};

export const USER_ROLES = {
  HR_PARTNER: 'HR_PARTNER',
  HR_ADMIN: 'HR_ADMIN',
};

export const REQUEST_TYPES = {
  MOVE: 'MOVE',
  AIRPORT_TRANSFER: 'AIRPORT_TRANSFER',
  HOUSING: 'HOUSING',
  SETTLING_IN: 'SETTLING_IN',
  SHORT_STAY: 'SHORT_STAY',
  TICKET: 'TICKET',
};

export const REQUEST_NAMES = {
  MOVE: 'Packers & Movers',
  AIRPORT_TRANSFER: 'Airport Transfer',
  HOUSING: 'Housing',
  SETTLING_IN: 'Settling-In services',
  SHORT_STAY: 'Short Stay',
  TICKET: 'Travel',
};

export const DASHBOARD_FILTERS = {
  '1W': '1W',
  '1M': '1M',
  '3M': '3M',
  '6M': '6M',
};

/**
 * Constants for <TODO:>
 */

// eslint-disable-next-line new-cap
export const DATA_LOAD_STATUS = Enum('LOADING', 'LOADED');

// eslint-disable-next-line new-cap
export const PAGE_ACTIONS = Enum('VIEW', 'ADD', 'EDIT', 'NO_RESULTS', 'UPLOAD');

// eslint-disable-next-line new-cap
export const ICON = Enum('CALL', 'EMAIL', 'USER');

export const validEmailRegex = RegExp(
  /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/i
);

export const validPhoneNumberRegex = RegExp(/^\+?([0-9]{12})$/);

export const nameRegex = RegExp(/^[A-Za-z\s]+$/);

export const designationRegex = RegExp(/^[a-zA-Z0-9 !@#$%^&*()\\-`.+,/]+$/);

export const employeeIdRegex = RegExp(/^[a-zA-Z0-9 !@#$%^&*()\\-`.+,/\"]*$/);

export const lettersRegex = RegExp(/(?:[^A-Za-z]*[a-zA-z]){4}$/);

export const valid10DigitPhoneNumberRegex = RegExp(/^\+?([0-9]{10})$/);

export const numbersRegex = RegExp(/^[0-9]+$/);

export const BULK_UPLOAD_STATUS = {
  BULK_UPLOAD_STARTED: 'BULK_UPLOAD_STARTED',
  BULK_UPLOAD_FINISHED: 'BULK_UPLOAD_FINISHED',
  BULK_UPLOAD_FAILED: 'BULK_UPLOAD_FAILED',
  UPLOAD: 'UPLOAD',
};
